<template>
  <div>
    <Header></Header>
    <div class="exam-wrapper">
      <div class="report-wrap">
        <div class="report-title">
          试题报告
        </div>
        <div style="margin: 0 45px 40px 45px;">
          <el-divider style="color: #F0F0F0;width: 100%;margin: 0;"></el-divider>
        </div>
        <div class="fraction">
          <div class="fraction-wrap">
            <div class="picture-wrap">
              <el-progress type="circle" :show-text="false" :percentage="detail.userScore" :width="180"
                :stroke-width="10">
                <!-- <template #default="{ userScore }">
                  <div class="circle-inner" style="color: #666;">
                    <div class="percentage-value">{{ detail.userScore }}</div>
                    <div style="width: 100px;height: 1px;background: #E4E4E4;margin: 8px 0;"></div>
                    <div class="percentage-label">分数</div>
                  </div>
                </template> -->
              </el-progress>
              <div class="circle-inner" style="color: #666;">
                <div class="percentage-value">{{ detail.userScore }}</div>
                <div style="width: 100px;height: 1px;background: #E4E4E4;margin: 8px 0;"></div>
                <div class="percentage-label">分数</div>
              </div>

            </div>
            <div class="data-wrap">
              <div class="time-title">交卷时间： {{ detail.limitTime }}</div>
              <div class="data-ul">
                <div class="data-li" style="width: 85px;">
                  <div>做对题数</div>
                  <div style="text-align: center;">{{ detail.rightNum }}</div>
                </div>
                <div class="data-li">
                  <div>做错题数</div>
                  <div>{{ detail.wrongNum }}</div>
                </div>
                <div class="data-li">
                  <div>未做题数</div>
                  <div>{{ detail.noAnsweredNum }}</div>
                </div>
                <div class="data-li">
                  <div>总题数</div>
                  <div>{{ listQu }}</div>
                </div>
              </div>
              <!-- <div class="prompt-text">
                <i class="el-icon-warning" style="margin-right: 3px;"></i>
                该卷含有主观题，主观题不参与评分
              </div> -->
              <div class="data-btn" style="margin-top: 30px;">
                <div class="btn" @click="onClickLeft">返回列表</div>
                <div class="btn" @click="toPageJx">查看解析</div>
                <div class="btn" @click="toPage">重新测试</div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin: 0 45px 40px 45px;">
          <el-divider style="color: #F0F0F0;width: 100%;margin: 0;"></el-divider>
        </div>
        <div class="bottom-wrap">
          <div class="bottom-inner">
            <div class="bottom-title">
              <div class="blue-line"></div>
              <div>本次练习</div>
            </div>
            <table border="1" cellspacing="0" style="width: 100%;margin-top: 40px;"
              v-if="detail.quType && detail.quType.length > 0">
              <tr
                style="height: 44px;background-color: #F8F8F8;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #333333;">
                <td>题型</td>
                <td>答对</td>
                <td>答错</td>
                <td>未做</td>
                <!-- <td>已做/总题量</td> -->
              </tr>
              <tr class="tr-other" v-for="item in detail.quType">
                <td>{{ item.quType == 1 ? '单选题' : (item.quType == 2 ? '多选题' : (item.quType == 3 ? '判断题' : (item.quType ==
                  4 ? '不定项' : (item.quType == 5 ? '主观题' : '综合题')))) }}</td>
                <td>{{ item.rightNum }}</td>
                <td>{{ item.wrongNum }}</td>
                <td>{{ item.noAnsweredNum }}</td>
              </tr>
            </table>
            <el-empty v-else description="暂无数据"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "./components/Header.vue";
import Header from "@/components/Header.vue";
import { getExamTestResult } from '@/api/apper.js'
export default {
  name: 'result',
  components: { Header },
  data() {
    return {
      listQu: 0,  // 总题数
      detail: {}, // 详情列表
      userPaperId: '', // 用户此次考试生成的考题id,每次测试会生成新的id
      apperId: '',  // 试卷id
      token: '',
      userScore: 0,
      specId: '',
      chaName: '',
    }
  },
  created() {
    this.token = window.localStorage.getItem('token')
    this.specId = JSON.parse(localStorage.getItem("specId"))

    this.apperId = this.$route.query.apperId
    this.listQu = this.$route.query.listQu
    this.userPaperId = this.$route.query.userPaperId
    this.chaName = this.$route.query.chaName
    this.getExamResultList(this.userPaperId)
  },
  methods: {
    getExamResultList(id) {
      getExamTestResult({ id: id }, { Authorization: this.token }).then(res => {
        console.log('试卷考试结果', res);
        this.detail = res.data
        this.userScore = res.data.userScore
      })
    },
    format(score) {
      return `${score} 分`
    },
    // 返回列表
    onClickLeft() {
      this.$router.push(`/ztDetails/${this.specId}`)
    },
    //查看解析
    toPageJx(type) {
      this.$router.push('/apper?jxLoadingAll=true&userPaperId=' + this.userPaperId + '&apperId=' + this.apperId + '&chaName=' + this.chaName)
    },
    //重做
    toPage(type) {
      this.$router.push('/apper?apperId=' + this.apperId + '&chaName=' + this.chaName)
    }
  },
}
</script>

<style lang="less" scoped>
.exam-wrapper {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px;
}

.report-wrap {
  width: 100%;
  background: white;
  border-radius: 8px;
  padding-bottom: 60px;
  border: 1px solid #EAEAEA;

  .report-title {
    width: 100%;
    height: 100px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    text-align: center;
    line-height: 100px;
    margin-bottom: -25px
  }

  .fraction {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;

    .fraction-wrap {
      min-height: 200px;
      min-width: 600px;
      align-items: center;
      display: flex;

      .picture-wrap {
        width: 190px;
        height: 190px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        .circle-inner {
          width: 140px;
          height: 140px;
          border-radius: 70px;
          margin: 0 auto;
          background: #FFFFFF;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: absolute;

          .percentage-value {
            font-size: 50px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #3E63EE;
          }

          .percentage-label {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }

        ::v-deep(.el-progress-circle__track) {
          stroke: #E1E8FF;
        }

        ::v-deep(.el-progress-circle__path) {
          stroke: #3E63EE;
        }
      }

      .data-wrap {
        margin-left: 20px;

        .time-title {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .data-ul {
          display: flex;
          margin: 20px 0;

          .data-li {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #606A74;
            border-right: 1px solid #E4E4E4;

            &:not(:first-child) {
              text-align: center;
              width: 105px;
            }

            &:nth-child(4) {
              border-right: none;
            }
          }
        }

        .prompt-text {
          height: 25px;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #EC5555;
        }

        .data-btn {
          display: flex;
          margin-top: 14px;

          .btn {
            width: 108px;
            height: 44px;
            border-radius: 6px;
            border: 1px solid #3E63EE;
            cursor: pointer;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3E63EE;
            line-height: 43px;
            text-align: center;

            &:nth-child(2) {
              margin: 0 20px;
            }
          }
        }
      }
    }
  }

  .bottom-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .bottom-inner {
      min-width: 810px;

      .bottom-title {
        display: flex;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        align-items: center;

        .blue-line {
          width: 6px;
          height: 24px;
          background: #3E63EE;
          border-radius: 3px;
          margin-right: 8px;
        }
      }

      .tr-other {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606A74;
        height: 44px;
      }

      table,
      td {
        border: 1px solid #CBCBCB;
        width: 20%;
        text-align: center;
      }
    }
  }
}</style>